module.exports = __webpack_public_path__ + "assets/img/video-btn-2d4b35fa.png";